"use strict";var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}; /*! modernizr 3.3.1 (Custom Build) | MIT *
                                                                                                                                                                                                                                                                                        * https://modernizr.com/download/?-adownload-animation-appearance-bgsizecover-boxsizing-canvas-checked-cookies-cryptography-cssanimations-csscalc-cssgradients-cssinvalid-csspointerevents-cssremunit-csstransforms-csstransforms3d-csstransitions-cssvalid-cssvhunit-cssvmaxunit-cssvminunit-cssvwunit-datalistelem-datauri-details-filereader-filesystem-flexbox-flexboxlegacy-flexboxtweener-formvalidation-framed-fullscreen-generatedcontent-geolocation-getusermedia-hidden-history-indexeddb-inlinesvg-input-inputtypes-localstorage-matchmedia-microdata-notification-nthchild-outputelem-pagevisibility-postmessage-progressbar_meter-search-serviceworker-sessionstorage-srcset-supports-svg-target-time-touchevents-video-webgl-websockets-websqldatabase-webworkers-addtest-mq-setclasses !*/
!function (e, t, n) {function i(e, t) {return (typeof e === "undefined" ? "undefined" : _typeof(e)) === t;}function r() {var e, t, n, r, o, a, s;for (var d in w) {if (w.hasOwnProperty(d)) {if (e = [], t = w[d], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (n = 0; n < t.options.aliases.length; n++) {e.push(t.options.aliases[n].toLowerCase());}for (r = i(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++) {a = e[o], s = a.split("."), 1 === s.length ? Modernizr[s[0]] = r : (!Modernizr[s[0]] || Modernizr[s[0]] instanceof Boolean || (Modernizr[s[0]] = new Boolean(Modernizr[s[0]])), Modernizr[s[0]][s[1]] = r), b.push((r ? "" : "no-") + s.join("-"));}}}}function o(e) {var t = _.className,n = Modernizr._config.classPrefix || "";if (E && (t = t.baseVal), Modernizr._config.enableJSClass) {var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");t = t.replace(i, "$1" + n + "js$2");}Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n), E ? _.className.baseVal = t : _.className = t);}function a(e, t) {if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e))) for (var n in e) {k(e, n) && a(n, e[n]);} else {e = e.toLowerCase();var i = e.split("."),r = Modernizr[i[0]];if (2 == i.length && (r = r[i[1]]), "undefined" != typeof r) return Modernizr;t = "function" == typeof t ? t() : t, 1 == i.length ? Modernizr[i[0]] = t : (!Modernizr[i[0]] || Modernizr[i[0]] instanceof Boolean || (Modernizr[i[0]] = new Boolean(Modernizr[i[0]])), Modernizr[i[0]][i[1]] = t), o([(t && 0 != t ? "" : "no-") + i.join("-")]), Modernizr._trigger(e, t);}return Modernizr;}function s() {return "function" != typeof t.createElement ? t.createElement(arguments[0]) : E ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments);}function d(e, t) {return e - 1 === t || e === t || e + 1 === t;}function l() {var e = t.body;return e || (e = s(E ? "svg" : "body"), e.fake = !0), e;}function u(e, n, i, r) {var o,a,d,u,c = "modernizr",f = s("div"),p = l();if (parseInt(i, 10)) for (; i--;) {d = s("div"), d.id = r ? r[i] : c + (i + 1), f.appendChild(d);}return o = s("style"), o.type = "text/css", o.id = "s" + c, (p.fake ? p : f).appendChild(o), p.appendChild(f), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(t.createTextNode(e)), f.id = c, p.fake && (p.style.background = "", p.style.overflow = "hidden", u = _.style.overflow, _.style.overflow = "hidden", _.appendChild(p)), a = n(f, e), p.fake ? (p.parentNode.removeChild(p), _.style.overflow = u, _.offsetHeight) : f.parentNode.removeChild(f), !!a;}function c(e) {return e.replace(/([a-z])-([a-z])/g, function (e, t, n) {return t + n.toUpperCase();}).replace(/^-/, "");}function f(e, t) {return !!~("" + e).indexOf(t);}function p(e, t) {return function () {return e.apply(t, arguments);};}function m(e, t, n) {var r;for (var o in e) {if (e[o] in t) return n === !1 ? e[o] : (r = t[e[o]], i(r, "function") ? p(r, n || t) : r);}return !1;}function h(e) {return e.replace(/([A-Z])/g, function (e, t) {return "-" + t.toLowerCase();}).replace(/^ms-/, "-ms-");}function v(t, i) {var r = t.length;if ("CSS" in e && "supports" in e.CSS) {for (; r--;) {if (e.CSS.supports(h(t[r]), i)) return !0;}return !1;}if ("CSSSupportsRule" in e) {for (var o = []; r--;) {o.push("(" + h(t[r]) + ":" + i + ")");}return o = o.join(" or "), u("@supports (" + o + ") { #modernizr { position: absolute; } }", function (e) {return "absolute" == getComputedStyle(e, null).position;});}return n;}function g(e, t, r, o) {function a() {l && (delete U.style, delete U.modElem);}if (o = i(o, "undefined") ? !1 : o, !i(r, "undefined")) {var d = v(e, r);if (!i(d, "undefined")) return d;}for (var l, u, p, m, h, g = ["modernizr", "tspan", "samp"]; !U.style && g.length;) {l = !0, U.modElem = s(g.shift()), U.style = U.modElem.style;}for (p = e.length, u = 0; p > u; u++) {if (m = e[u], h = U.style[m], f(m, "-") && (m = c(m)), U.style[m] !== n) {if (o || i(r, "undefined")) return a(), "pfx" == t ? m : !0;try {U.style[m] = r;} catch (y) {}if (U.style[m] != h) return a(), "pfx" == t ? m : !0;}}return a(), !1;}function y(e, t, n, r, o) {var a = e.charAt(0).toUpperCase() + e.slice(1),s = (e + " " + R.join(a + " ") + a).split(" ");return i(t, "string") || i(t, "undefined") ? g(s, t, r, o) : (s = (e + " " + D.join(a + " ") + a).split(" "), m(s, t, n));}function T(e, t, i) {return y(e, n, n, t, i);}var b = [],w = [],x = { _version: "3.3.1", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, t) {var n = this;setTimeout(function () {t(n[e]);}, 0);}, addTest: function addTest(e, t, n) {w.push({ name: e, fn: t, options: n });}, addAsyncTest: function addAsyncTest(e) {w.push({ name: null, fn: e });} },Modernizr = function Modernizr() {};Modernizr.prototype = x, Modernizr = new Modernizr(), Modernizr.addTest("cookies", function () {try {t.cookie = "cookietest=1";var e = -1 != t.cookie.indexOf("cookietest=");return t.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT", e;} catch (n) {return !1;}}), Modernizr.addTest("history", function () {var t = navigator.userAgent;return -1 === t.indexOf("Android 2.") && -1 === t.indexOf("Android 4.0") || -1 === t.indexOf("Mobile Safari") || -1 !== t.indexOf("Chrome") || -1 !== t.indexOf("Windows Phone") ? e.history && "pushState" in e.history : !1;}), Modernizr.addTest("geolocation", "geolocation" in navigator), Modernizr.addTest("notification", function () {if (!e.Notification || !e.Notification.requestPermission) return !1;if ("granted" === e.Notification.permission) return !0;try {new e.Notification("");} catch (t) {if ("TypeError" === t.name) return !1;}return !0;}), Modernizr.addTest("postmessage", "postMessage" in e), Modernizr.addTest("serviceworker", "serviceWorker" in navigator), Modernizr.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);var A = !1;try {A = "WebSocket" in e && 2 === e.WebSocket.CLOSING;} catch (S) {}Modernizr.addTest("websockets", A);var C = "CSS" in e && "supports" in e.CSS,z = "supportsCSS" in e;Modernizr.addTest("supports", C || z), Modernizr.addTest("target", function () {var t = e.document;if (!("querySelectorAll" in t)) return !1;try {return t.querySelectorAll(":target"), !0;} catch (n) {return !1;}}), Modernizr.addTest("microdata", "getItems" in t), Modernizr.addTest("filereader", !!(e.File && e.FileList && e.FileReader)), Modernizr.addTest("localstorage", function () {var e = "modernizr";try {return localStorage.setItem(e, e), localStorage.removeItem(e), !0;} catch (t) {return !1;}}), Modernizr.addTest("sessionstorage", function () {var e = "modernizr";try {return sessionStorage.setItem(e, e), sessionStorage.removeItem(e), !0;} catch (t) {return !1;}}), Modernizr.addTest("websqldatabase", "openDatabase" in e), Modernizr.addTest("webworkers", "Worker" in e);var k,_ = t.documentElement,E = "svg" === _.nodeName.toLowerCase();!function () {var e = {}.hasOwnProperty;k = i(e, "undefined") || i(e.call, "undefined") ? function (e, t) {return t in e && i(e.constructor.prototype[t], "undefined");} : function (t, n) {return e.call(t, n);};}(), x._l = {}, x.on = function (e, t) {this._l[e] || (this._l[e] = []), this._l[e].push(t), Modernizr.hasOwnProperty(e) && setTimeout(function () {Modernizr._trigger(e, Modernizr[e]);}, 0);}, x._trigger = function (e, t) {if (this._l[e]) {var n = this._l[e];setTimeout(function () {var e, i;for (e = 0; e < n.length; e++) {(i = n[e])(t);}}, 0), delete this._l[e];}}, Modernizr._q.push(function () {x.addTest = a;}), Modernizr.addAsyncTest(function () {function e() {var e = new Image();e.onerror = function () {a("datauri", !0), Modernizr.datauri = new Boolean(!0), Modernizr.datauri.over32kb = !1;}, e.onload = function () {a("datauri", !0), Modernizr.datauri = new Boolean(!0), Modernizr.datauri.over32kb = 1 == e.width && 1 == e.height;};for (var t = "R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="; t.length < 33e3;) {t = "\r\n" + t;}e.src = "data:image/gif;base64," + t;}-1 !== navigator.userAgent.indexOf("MSIE 7.") && setTimeout(function () {a("datauri", !1);}, 10);var t = new Image();t.onerror = function () {a("datauri", !1);}, t.onload = function () {1 == t.width && 1 == t.height ? e() : a("datauri", !1);}, t.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";}), Modernizr.addTest("canvas", function () {var e = s("canvas");return !(!e.getContext || !e.getContext("2d"));}), Modernizr.addTest("video", function () {var e = s("video"),t = !1;try {(t = !!e.canPlayType) && (t = new Boolean(t), t.ogg = e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, ""), t.h264 = e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, ""), t.webm = e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, ""), t.vp9 = e.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, ""), t.hls = e.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, ""));} catch (n) {}return t;}), Modernizr.addTest("webanimations", "animate" in s("div")), Modernizr.addTest("webgl", function () {var t = s("canvas"),n = "probablySupportsContext" in t ? "probablySupportsContext" : "supportsContext";return n in t ? t[n]("webgl") || t[n]("experimental-webgl") : "WebGLRenderingContext" in e;}), Modernizr.addTest("adownload", !e.externalHost && "download" in s("a")), Modernizr.addTest("csspointerevents", function () {var e = s("a").style;return e.cssText = "pointer-events:auto", "auto" === e.pointerEvents;}), Modernizr.addTest("cssremunit", function () {var e = s("a").style;try {e.fontSize = "3rem";} catch (t) {}return (/rem/.test(e.fontSize));}), Modernizr.addTest("hidden", "hidden" in s("a")), Modernizr.addTest("outputelem", "value" in s("output")), Modernizr.addTest("progressbar", s("progress").max !== n), Modernizr.addTest("meter", s("meter").max !== n), Modernizr.addTest("time", "valueAsDate" in s("time")), Modernizr.addTest("srcset", "srcset" in s("img")), Modernizr.addTest("inlinesvg", function () {var e = s("div");return e.innerHTML = "<svg/>", "http://www.w3.org/2000/svg" == ("undefined" != typeof SVGRect && e.firstChild && e.firstChild.namespaceURI);});var P = s("input"),N = "autocomplete autofocus list placeholder max min multiple pattern required step".split(" "),I = {};Modernizr.input = function (t) {for (var n = 0, i = t.length; i > n; n++) {I[t[n]] = !!(t[n] in P);}return I.list && (I.list = !(!s("datalist") || !e.HTMLDataListElement)), I;}(N), Modernizr.addTest("datalistelem", Modernizr.input.list);var O = "search tel url email datetime date month week time datetime-local number range color".split(" "),L = {};Modernizr.inputtypes = function (e) {for (var i, r, o, a = e.length, s = "1)", d = 0; a > d; d++) {P.setAttribute("type", i = e[d]), o = "text" !== P.type && "style" in P, o && (P.value = s, P.style.cssText = "position:absolute;visibility:hidden;", /^range$/.test(i) && P.style.WebkitAppearance !== n ? (_.appendChild(P), r = t.defaultView, o = r.getComputedStyle && "textfield" !== r.getComputedStyle(P, null).WebkitAppearance && 0 !== P.offsetHeight, _.removeChild(P)) : /^(search|tel)$/.test(i) || (o = /^(url|email)$/.test(i) ? P.checkValidity && P.checkValidity() === !1 : P.value != s)), L[e[d]] = !!o;}return L;}(O);var M = function () {function e(e, t) {var r;return e ? (t && "string" != typeof t || (t = s(t || "div")), e = "on" + e, r = e in t, !r && i && (t.setAttribute || (t = s("div")), t.setAttribute(e, ""), r = "function" == typeof t[e], t[e] !== n && (t[e] = n), t.removeAttribute(e)), r) : !1;}var i = !("onblur" in t.documentElement);return e;}();x.hasEvent = M, Modernizr.addTest("inputsearchevent", M("search"));var W = x._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];x._prefixes = W, Modernizr.addTest("csscalc", function () {var e = "width:",t = "calc(10px);",n = s("a");return n.style.cssText = e + W.join(t + e), !!n.style.length;}), Modernizr.addTest("cssgradients", function () {for (var e, t = "background-image:", n = "gradient(linear,left top,right bottom,from(#9f9),to(white));", i = "", r = 0, o = W.length - 1; o > r; r++) {e = 0 === r ? "to " : "", i += t + W[r] + "linear-gradient(" + e + "left top, #9f9, white);";}Modernizr._config.usePrefixes && (i += t + "-webkit-" + n);var a = s("a"),d = a.style;return d.cssText = i, ("" + d.backgroundImage).indexOf("gradient") > -1;});var q = function () {var t = e.matchMedia || e.msMatchMedia;return t ? function (e) {var n = t(e);return n && n.matches || !1;} : function (t) {var n = !1;return u("@media " + t + " { #modernizr { position: absolute; } }", function (t) {n = "absolute" == (e.getComputedStyle ? e.getComputedStyle(t, null) : t.currentStyle).position;}), n;};}();x.mq = q;var B = x.testStyles = u;Modernizr.addTest("touchevents", function () {var n;if ("ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch) n = !0;else {var i = ["@media (", W.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");B(i, function (e) {n = 9 === e.offsetTop;});}return n;}), Modernizr.addTest("checked", function () {return B("#modernizr {position:absolute} #modernizr input {margin-left:10px} #modernizr :checked {margin-left:20px;display:block}", function (e) {var t = s("input");return t.setAttribute("type", "checkbox"), t.setAttribute("checked", "checked"), e.appendChild(t), 20 === t.offsetLeft;});}), B('#modernizr{font:0/0 a}#modernizr:after{content:":)";visibility:hidden;font:7px/1 a}', function (e) {Modernizr.addTest("generatedcontent", e.offsetHeight >= 7);}), Modernizr.addTest("cssinvalid", function () {return B("#modernizr input{height:0;border:0;padding:0;margin:0;width:10px} #modernizr input:invalid{width:50px}", function (e) {var t = s("input");return t.required = !0, e.appendChild(t), t.clientWidth > 10;});}), B("#modernizr div {width:1px} #modernizr div:nth-child(2n) {width:2px;}", function (e) {for (var t = e.getElementsByTagName("div"), n = !0, i = 0; 5 > i; i++) {n = n && t[i].offsetWidth === i % 2 + 1;}Modernizr.addTest("nthchild", n);}, 5), Modernizr.addTest("cssvalid", function () {return B("#modernizr input{height:0;border:0;padding:0;margin:0;width:10px} #modernizr input:valid{width:50px}", function (e) {var t = s("input");return e.appendChild(t), t.clientWidth > 10;});}), B("#modernizr { height: 50vh; }", function (t) {var n = parseInt(e.innerHeight / 2, 10),i = parseInt((e.getComputedStyle ? getComputedStyle(t, null) : t.currentStyle).height, 10);Modernizr.addTest("cssvhunit", i == n);}), B("#modernizr1{width: 50vmax}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}", function (t) {var n = t.childNodes[2],i = t.childNodes[1],r = t.childNodes[0],o = parseInt((i.offsetWidth - i.clientWidth) / 2, 10),a = r.clientWidth / 100,s = r.clientHeight / 100,l = parseInt(50 * Math.max(a, s), 10),u = parseInt((e.getComputedStyle ? getComputedStyle(n, null) : n.currentStyle).width, 10);Modernizr.addTest("cssvmaxunit", d(l, u) || d(l, u - o));}, 3), B("#modernizr1{width: 50vm;width:50vmin}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}", function (t) {var n = t.childNodes[2],i = t.childNodes[1],r = t.childNodes[0],o = parseInt((i.offsetWidth - i.clientWidth) / 2, 10),a = r.clientWidth / 100,s = r.clientHeight / 100,l = parseInt(50 * Math.min(a, s), 10),u = parseInt((e.getComputedStyle ? getComputedStyle(n, null) : n.currentStyle).width, 10);Modernizr.addTest("cssvminunit", d(l, u) || d(l, u - o));}, 3), B("#modernizr { width: 50vw; }", function (t) {var n = parseInt(e.innerWidth / 2, 10),i = parseInt((e.getComputedStyle ? getComputedStyle(t, null) : t.currentStyle).width, 10);Modernizr.addTest("cssvwunit", i == n);}), Modernizr.addTest("details", function () {var e,t = s("details");return "open" in t ? (B("#modernizr details{display:block}", function (n) {n.appendChild(t), t.innerHTML = "<summary>a</summary>b", e = t.offsetHeight, t.open = !0, e = e != t.offsetHeight;}), e) : !1;}), Modernizr.addTest("formvalidation", function () {var t = s("form");if (!("checkValidity" in t && "addEventListener" in t)) return !1;if ("reportValidity" in t) return !0;var n,i = !1;return Modernizr.formvalidationapi = !0, t.addEventListener("submit", function (t) {(!e.opera || e.operamini) && t.preventDefault(), t.stopPropagation();}, !1), t.innerHTML = '<input name="modTest" required="required" /><button></button>', B("#modernizr form{position:absolute;top:-99999em}", function (e) {e.appendChild(t), n = t.getElementsByTagName("input")[0], n.addEventListener("invalid", function (e) {i = !0, e.preventDefault(), e.stopPropagation();}, !1), Modernizr.formvalidationmessage = !!n.validationMessage, t.getElementsByTagName("button")[0].click();}), i;});var H = "Moz O ms Webkit",R = x._config.usePrefixes ? H.split(" ") : [];x._cssomPrefixes = R;var j = function j(t) {var i,r = W.length,o = e.CSSRule;if ("undefined" == typeof o) return n;if (!t) return !1;if (t = t.replace(/^@/, ""), i = t.replace(/-/g, "_").toUpperCase() + "_RULE", i in o) return "@" + t;for (var a = 0; r > a; a++) {var s = W[a],d = s.toUpperCase() + "_" + i;if (d in o) return "@-" + s.toLowerCase() + "-" + t;}return !1;};x.atRule = j;var D = x._config.usePrefixes ? H.toLowerCase().split(" ") : [];x._domPrefixes = D;var $ = { elem: s("modernizr") };Modernizr._q.push(function () {delete $.elem;});var U = { style: $.elem.style };Modernizr._q.unshift(function () {delete U.style;}), x.testAllProps = y;var V = x.prefixed = function (e, t, n) {return 0 === e.indexOf("@") ? j(e) : (-1 != e.indexOf("-") && (e = c(e)), t ? y(e, t, n) : y(e, "pfx"));};Modernizr.addTest("fullscreen", !(!V("exitFullscreen", t, !1) && !V("cancelFullScreen", t, !1)));var G;try {G = V("indexedDB", e);} catch (S) {}Modernizr.addTest("indexeddb", !!G), G && Modernizr.addTest("indexeddb.deletedatabase", "deleteDatabase" in G);var F = V("crypto", e);Modernizr.addTest("crypto", !!V("subtle", F)), Modernizr.addTest("pagevisibility", !!V("hidden", t, !1)), Modernizr.addTest("filesystem", !!V("requestFileSystem", e)), Modernizr.addTest("getusermedia", !!V("getUserMedia", navigator)), Modernizr.addTest("matchmedia", !!V("matchMedia", e)), x.testAllProps = T, Modernizr.addTest("cssanimations", T("animationName", "a", !0)), Modernizr.addTest("appearance", T("appearance")), Modernizr.addTest("bgsizecover", T("backgroundSize", "cover")), Modernizr.addTest("boxsizing", T("boxSizing", "border-box", !0) && (t.documentMode === n || t.documentMode > 7)), Modernizr.addTest("flexbox", T("flexBasis", "1px", !0)), Modernizr.addTest("flexboxlegacy", T("boxDirection", "reverse", !0)), Modernizr.addTest("flexboxtweener", T("flexAlign", "end", !0)), Modernizr.addTest("csstransforms", function () {return -1 === navigator.userAgent.indexOf("Android 2.") && T("transform", "scale(1)", !0);}), Modernizr.addTest("csstransforms3d", function () {var e = !!T("perspective", "1px", !0),t = Modernizr._config.usePrefixes;if (e && (!t || "webkitPerspective" in _.style)) {var n,i = "#modernizr{width:0;height:0}";Modernizr.supports ? n = "@supports (perspective: 1px)" : (n = "@media (transform-3d)", t && (n += ",(-webkit-transform-3d)")), n += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}", B(i + n, function (t) {e = 7 === t.offsetWidth && 18 === t.offsetHeight;});}return e;}), Modernizr.addTest("csstransitions", T("transition", "all", !0)), Modernizr.addTest("framed", e.location != top.location), r(), o(b), delete x.addTest, delete x.addAsyncTest;for (var Q = 0; Q < Modernizr._q.length; Q++) {Modernizr._q[Q]();}e.Modernizr = Modernizr;}(window, document);
'use strict'; /********
              ****** NinjaSlider, multipurpose html slider, it relies heavily in Function.prototype.bind, RequesAnimationFrame and css transitions
              ****** Support: IE10+
              ****** Author: Fernando Silva
              ****** URL: http://www.github.com/fdograph
              *****/

/////////////////////////////////
///////////////////////////////// NinjaSlider Class
/////////////////////////////////
(function (window, document) {
    "strict mode";

    var support = {
        touch: 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch,
        pointers: window.navigator.msPointerEnabled || window.navigator.pointerEnabled,
        transitions: function (temp) {
            var props = ['transitionProperty', 'WebkitTransition'],
            i;
            for (i in props) {if (temp.style[props[i]] !== undefined) {return true;}}
            return false;
        }(document.createElement('ninja')) };


    ///// auxiliars
    var addListeners = function addListeners(element, events, handler) {
        events.forEach(function (e) {
            element.addEventListener(e, handler);
        });
    };
    var removeListeners = function removeListeners(element, events, handler) {
        events.forEach(function (e) {
            element.removeEventListener(e, handler);
        });
    };
    var getCoords = function getCoords(event) {
        var x, y;

        if (support.touch) {
            if (event.touches && event.touches[0]) {
                x = event.touches[0].pageX;
                y = event.touches[0].pageY;
            } else
            if (event.changedTouches && event.changedTouches[0]) {
                x = event.changedTouches[0].pageX;
                y = event.changedTouches[0].pageY;
            }
        } else
        {
            x = event.pageX;
            y = event.pageY;
        }

        return { x: x, y: y };
    };
    var extend = function extend() {
        var i, key;
        for (i = 1; i < arguments.length; i++) {
            for (key in arguments[i]) {
                if (arguments[i].hasOwnProperty(key)) {
                    arguments[0][key] = arguments[i][key];
                }
            }
        }
        return arguments[0];
    };

    window.NinjaSlider = function (container, options) {
        if (!support.transitions) {return false;}

        this.defaults = {
            auto: 2000,
            speed: 300,
            throttle: 300,
            effect: 'slide',
            handleKeys: true,
            blockScrolling: false
            // transitionCallback : function( index, item, slider ){},
        };
        this.settings = extend(this.defaults, options || {});

        this.container = container;
        this.list = this.container.children[0];
        this.items = Array.prototype.map.call(this.list.children, function (e) {return e;});

        /// events closures
        this.setupClosures();

        this.initialized = false;
        this.resizeTimeout = null;
        this.setup();
        this.eventsHandler('engage');

        if (this.settings.auto) {
            this.autoInterval = setInterval(this.next.bind(this), this.settings.auto);
        }

        var effect = this.settings.effect;
        if (typeof this.effects[effect].init === 'function') {
            this.effects[effect].init(this);
        }

        return {
            slide: this.slide.bind(this),
            prev: this.prev.bind(this),
            next: this.next.bind(this),
            kill: this.kill.bind(this) };

    };

    window.NinjaSlider.prototype = {
        ///// configs
        setup: function setup() {
            this.width = this.container.getBoundingClientRect().width || this.container.offsetWidth;
            this.currentIndex = this.currentIndex ? this.currentIndex : 0;
            this.slidesPos = [];

            var effect = this.settings.effect;
            this.effects[effect].setup(this);
            this.initialized = true;
        },
        kill: function kill() {
            var effect = this.settings.effect;
            this.effects[effect].kill(this);
            this.initialized = false;
        },
        setupClosures: function setupClosures() {
            this.resize = this.onResize.bind(this);
            this.start = this.onStart.bind(this);
            this.move = this.onMove.bind(this);
            this.end = this.onEnd.bind(this);

            if (this.settings.auto) {
                this.stopAuto = function () {
                    if (this.autoInterval) {
                        clearInterval(this.autoInterval);
                        this.autoInterval = undefined;
                    }
                    removeListeners(this.container, ['mousedown', 'touchstart', 'keydown'], this.stopAuto);
                }.bind(this);
            }

            if (this.settings.handleKeys) {
                this.keysHandler = function (event) {
                    if (event.keyCode == '39') {this.next();} else
                    if (event.keyCode == '37') {this.prev();}
                }.bind(this);
            }
        },
        eventsHandler: function eventsHandler(action) {
            if (action === 'engage') {
                addListeners(this.list, ['touchstart', 'mousedown'], this.start);
                addListeners(this.list, ['mousedown', 'touchstart', 'keydown'], this.stopAuto);

                if (this.settings.handleKeys) {
                    document.addEventListener('keydown', this.keysHandler);
                }

                window.addEventListener('resize', this.resize);
            } else
            {
                removeListeners(this.list, ['touchstart', 'mousedown'], this.start);
                removeListeners(this.list, ['mousedown', 'touchstart', 'keydown'], this.stopAuto);

                if (this.settings.handleKeys) {
                    document.removeEventListener('keydown', this.keysHandler);
                }

                window.removeEventListener('resize', this.resize);
            }
        },
        prev: function prev() {
            var target = this.currentIndex === 0 ? this.items.length - 1 : this.currentIndex - 1;
            var effect = this.settings.effect;
            this.effects[effect].slide(this, target);

            if (typeof this.settings.transitionCallback === 'function' && this.items[this.currentIndex]) {
                this.settings.transitionCallback(this.currentIndex, this.items[this.currentIndex], this);
            }
        },
        next: function next() {
            var target = this.currentIndex === this.items.length - 1 ? 0 : this.currentIndex + 1;
            var effect = this.settings.effect;
            this.effects[effect].slide(this, target, this.settings.speed);

            if (typeof this.settings.transitionCallback === 'function' && this.items[this.currentIndex]) {
                this.settings.transitionCallback(this.currentIndex, this.items[this.currentIndex], this);
            }
        },
        slide: function slide(to, time) {
            var effect = this.settings.effect;
            console.log();
            this.effects[effect].slide(this, to, time);

            if (typeof this.settings.transitionCallback === 'function' && this.items[this.currentIndex]) {
                this.settings.transitionCallback(this.currentIndex, this.items[this.currentIndex], this);
            }
        },

        ///// delegations
        onResize: function onResize() {
            clearTimeout(this.resizeTimeout);
            // closure for the resize timeout
            // lets not kill performance
            this.resizeTimeout = setTimeout(function (ninjaSlider) {
                return function () {
                    ninjaSlider.setup();
                };
            }(this), this.settings.throttle);
        },
        onStart: function onStart(event) {
            if (event.type === 'mousedown') {event.preventDefault();}

            var pointerCoors = getCoords(event);

            this.startPos = {
                x: pointerCoors.x,
                y: pointerCoors.y,
                time: new Date() };


            this.delta = {};

            this.isScrolling = undefined;

            var effect = this.settings.effect;
            if (typeof this.effects[effect].onStart === 'function') {
                this.effects[effect].onStart(this, pointerCoors, event);
            }

            addListeners(this.container, ['touchmove', 'mousemove'], this.move);
            addListeners(this.container, ['touchend', 'mouseup'], this.end);
        },
        onMove: function onMove(event) {
            var pointerCoors = getCoords(event);

            this.delta = {
                x: pointerCoors.x - this.startPos.x,
                y: pointerCoors.y - this.startPos.y };


            if (typeof this.isScrolling === 'undefined') {
                this.isScrolling = !!(this.isScrolling || Math.abs(this.delta.x) < Math.abs(this.delta.y));
            }

            if (this.isScrolling && !this.settings.blockScrolling) {
                return;
            }

            event.preventDefault();

            var effect = this.settings.effect;
            this.effects[effect].onMove(this, pointerCoors, event);
        },
        onEnd: function onEnd(event) {
            // event.preventDefault();

            var pointerCoors = getCoords(event);
            var duration = new Date() - this.startPos.time,
            direction = this.delta.x < 0,
            targetIndex = this.currentIndex;

            var isValidSlide = Number(duration) < 250 && Math.abs(this.delta.x) > 40 || Math.abs(this.delta.x) > this.width / 2,
            isPastBounds = !this.currentIndex && this.delta.x > 0 || this.currentIndex === this.items.length - 1 && this.delta.x < 0;

            if (isValidSlide && !isPastBounds) {
                targetIndex = direction ? this.currentIndex + 1 : this.currentIndex - 1;
            }

            var effect = this.settings.effect;
            if (typeof this.effects[effect].onEnd === 'function') {
                this.effects[effect].onEnd(this, pointerCoors, targetIndex, event);
            }

            if (typeof this.settings.transitionCallback === 'function' && this.items[this.currentIndex]) {
                this.settings.transitionCallback(this.currentIndex, this.items[this.currentIndex], this);
            }

            removeListeners(this.container, ['touchmove', 'mousemove'], this.move);
            removeListeners(this.container, ['touchend', 'mouseup'], this.end);
        },


        //// effects
        effects: {},

        // settings
        settings: {} };


    window.NinjaSlider.addEffect = function (effectName, effectObject) {
        NinjaSlider.prototype.effects[effectName] = effectObject;
    };

    // wrapper in jquery
    if (jQuery) {
        jQuery.fn.ninjaSlider = function (options) {
            if (this.data('ninjaSlider')) {return this.data('ninjaSlider');}
            return this.each(function () {
                $(this).data('ninjaSlider', new window.NinjaSlider(this, options));
            });
        };
    }
})(window, document);


/////////////////////////////////
///////////////////////////////// Effects
/////////////////////////////////

(function (window, document) {
    "use strict";

    var calcOffset = function calcOffset(width, index) {
        var calc = index * width * -1;
        if (index === 0) {calc = calc - width;}
        return calc;
    };

    var changeStyle = function changeStyle(element, props, value) {
        props.forEach(function (p) {
            element.style[p] = value;
        });
    };

    var move = function move(item, offset, speed) {
        changeStyle(item, ['webkitTransitionDuration', 'MozTransitionDuration', 'msTransitionDuration', 'transitionDuration'], speed + 'ms');
        changeStyle(item, ['webkitTransform', 'MozTransform', 'msTransform', 'transform'], 'translate(' + offset + 'px,0) translateZ(0)');
    };

    var closestNum = function closestNum(num, arr) {
        // si el array esta vacio se devuelve el numero
        if (!arr.length) {return num;}

        // si solo tiene un numero entonces
        // se devuelve el primero
        else if (arr.length === 1) {return arr[0];}

        var curr = arr[0],
        diff = Math.abs(num - curr);

        arr.forEach(function (n, index) {
            var newDiff = Math.abs(num - n);

            if (newDiff < diff) {
                diff = newDiff;
                curr = n;
            }
        });

        return curr;
    };

    /////////////////////////////////
    ///////////////////////////////// Slide effect
    /////////////////////////////////
    window.NinjaSlider.addEffect('slide', {
        setup: function setup(ninjaSlider) {
            ninjaSlider.container.style.visibility = 'visible';
            changeStyle(ninjaSlider.container, ['webkitBackfaceVisibility', 'mozBackfaceVisibility', 'msBackfaceVisibility', 'backfaceVisibility'], 'hidden');
            changeStyle(ninjaSlider.container, ['webkitPerspective', 'mozPerspective', 'msPerspective', 'perspective'], 1000);
            ninjaSlider.list.style.width = ninjaSlider.width * ninjaSlider.items.length + 'px';

            ninjaSlider.items.forEach(function (item, i) {
                var offset_calc = calcOffset(ninjaSlider.width, i) + ninjaSlider.width;

                item.style.width = ninjaSlider.width + 'px';
                changeStyle(item, ['webkitTransform', 'MozTransform', 'msTransform', 'transform'], 'move(' + offset_calc + 'px,0) moveZ(0)');

                if (!ninjaSlider.initialized) {
                    item.style.float = 'left';
                    item.dataset.index = i;
                    changeStyle(item, ['webkitTransitionDuration', 'MozTransitionDuration', 'msTransitionDuration', 'transitionDuration'], ninjaSlider.settings.speed + 'ms');
                    item.dataset.offset = offset_calc;
                    ninjaSlider.slidesPos.push(offset_calc);
                }
            });

            if (ninjaSlider.initialized) {
                ninjaSlider.effects[ninjaSlider.settings.effect].slide(ninjaSlider, ninjaSlider.currentIndex, 0);
            }
        },
        kill: function kill(ninjaSlider) {
            ninjaSlider.container.removeAttribute('style');
            ninjaSlider.list.removeAttribute('style');
            ninjaSlider.items.forEach(function (item) {
                item.removeAttribute('style');
            });
            ninjaSlider.eventsHandler('disengage');
            ninjaSlider.initialized = false;
        },
        slide: function slide(ninjaSlider, to, speed) {
            var current = ninjaSlider.currentIndex,
            items = ninjaSlider.items,
            width = ninjaSlider.width,
            prev = current < to ? current : to - 1,
            next = current > to ? current : to + 1,
            offset_prev,offset_target,offset_next;

            speed = typeof speed === 'undefined' ? ninjaSlider.settings.speed : speed;

            if (items[prev]) {
                offset_prev = calcOffset(ninjaSlider.width, prev);
                if (prev !== 0) {offset_prev = offset_prev - width;}

                move(items[prev], offset_prev, speed);
                ninjaSlider.slidesPos[prev] = offset_prev;
                items[prev].dataset.offset = offset_prev;
            }

            if (items[to]) {
                offset_target = calcOffset(ninjaSlider.width, to);
                if (to === 0) {offset_target = offset_target + width;}

                move(items[to], offset_target, speed);
                ninjaSlider.slidesPos[to] = offset_target;
                items[to].dataset.offset = offset_target;
            }

            if (items[next]) {
                offset_next = calcOffset(ninjaSlider.width, next) + width;
                move(items[next], offset_next, speed);
                ninjaSlider.slidesPos[next] = offset_next;
                items[next].dataset.offset = offset_next;
            }

            items.filter(function (el, i) {
                return i < to && i !== prev || i > to && i !== next;
            }).forEach(function (el) {
                var index = items.indexOf(el),
                direction = index > to,
                offset = calcOffset(ninjaSlider.width, index);

                if (index !== 0 && !direction) {offset = offset - width;} else
                if (direction) {offset = offset + width;}

                move(el, offset, 0);
                ninjaSlider.slidesPos[index] = offset;
                el.dataset.offset = offset;
            });

            ninjaSlider.currentIndex = to;
        },
        onMove: function onMove(ninjaSlider) {
            var slidesPos = ninjaSlider.slidesPos,
            prev = ninjaSlider.items[ninjaSlider.currentIndex - 1],
            current = ninjaSlider.items[ninjaSlider.currentIndex],
            next = ninjaSlider.items[ninjaSlider.currentIndex + 1],
            deltaX;

            ninjaSlider.delta.x = ninjaSlider.delta.x / (

            !ninjaSlider.currentIndex && ninjaSlider.delta.x > 0 ||
            ninjaSlider.currentIndex === ninjaSlider.items.length - 1 &&
            ninjaSlider.delta.x < 0 ?
            Math.abs(ninjaSlider.delta.x) / ninjaSlider.width + 1 : 1);

            deltaX = ninjaSlider.delta.x;

            if (prev) {move(prev, deltaX + slidesPos[ninjaSlider.currentIndex - 1], 0);}
            move(current, deltaX + slidesPos[ninjaSlider.currentIndex], 0);
            if (next) {move(next, deltaX + slidesPos[ninjaSlider.currentIndex + 1], 0);}
        },
        onEnd: function onEnd(ninjaSlider, pointerCoors, targetIndex, event) {
            ninjaSlider.effects[ninjaSlider.settings.effect].slide(ninjaSlider, targetIndex, ninjaSlider.settings.speed);
        } });




    /////////////////////////////////
    ///////////////////////////////// carousel effect
    /////////////////////////////////
    window.NinjaSlider.addEffect('carousel', {
        setup: function setup(ninjaSlider) {
            // structure changes when is a carousel
            // one more layer added for scrolling items
            ninjaSlider.listHolder = ninjaSlider.container.children[0];
            ninjaSlider.list = ninjaSlider.listHolder.children[0];
            ninjaSlider.items = Array.prototype.map.call(ninjaSlider.list.children, function (e) {return e;});

            // ancho del contenedor de la lista
            ninjaSlider.holderWIdth = ninjaSlider.listHolder.getBoundingClientRect().width || ninjaSlider.listHolder.offsetWidth;

            ninjaSlider.listPos = 0;

            // numero maximo de items
            var maxItems = ninjaSlider.settings.itemsConf && ninjaSlider.settings.itemsConf.base || 5;

            if (ninjaSlider.settings.itemsConf && ninjaSlider.settings.itemsConf.medias) {
                ninjaSlider.settings.itemsConf.medias.forEach(function (mqinfo) {
                    var breakpoint = mqinfo[0],
                    itemsNum = mqinfo[1];

                    if (window.matchMedia('screen and (max-width: ' + breakpoint + ')').matches) {
                        maxItems = itemsNum;
                    }
                });
            }

            var itemWidth;

            // max items styles
            if (maxItems) {
                itemWidth = ninjaSlider.holderWIdth / maxItems;

                // seteo de estilos por item
                ninjaSlider.items.forEach(function (item, i) {
                    item.dataset.index = i;
                    changeStyle(item, ['min-width', 'width', 'max-width'], itemWidth + 'px');
                });
            }

            // se indica el primer item como el activo
            ninjaSlider.items[0].dataset.current = true;

            // estilos bases para aceleracion gpu
            ninjaSlider.container.style.visibility = 'visible';
            changeStyle(ninjaSlider.container, ['webkitBackfaceVisibility', 'mozBackfaceVisibility', 'msBackfaceVisibility', 'backfaceVisibility'], 'hidden');
            changeStyle(ninjaSlider.container, ['webkitPerspective', 'mozPerspective', 'msPerspective', 'perspective'], 1000);

            // la lista debe ser relativa para que el.offsetLeft de el valor correcto
            ninjaSlider.list.style.position = 'relative';

            // la lista se vuelve del tamano de todos sus items
            ninjaSlider.listWIdth = itemWidth * ninjaSlider.items.length;
            ninjaSlider.list.style.width = ninjaSlider.listWIdth + 'px';

            // velocidad de transicion para la lista
            changeStyle(ninjaSlider.list, ['webkitTransitionDuration', 'MozTransitionDuration', 'msTransitionDuration', 'transitionDuration'], ninjaSlider.settings.speed + 'ms');
        },
        kill: function kill(ninjaSlider) {
        },
        slide: function slide(ninjaSlider, to, speed) {
            // si se requiere un index inexistente
            if (!ninjaSlider.items[to]) {
                console.warn('Se ingresó un index invalido o no existente: ', to);
                return;
            }

            // se indica el item activo
            ninjaSlider.items.forEach(function (item, i) {
                item.dataset.current = false;
            });
            ninjaSlider.items[to].dataset.current = true;

            // la lista se muevo solo en el caso de que el offset sea
            // menor a la resta del ancho del contenedor y de la lista
            ninjaSlider.listPos = ninjaSlider.items[to].offsetLeft;
            if (ninjaSlider.listPos > ninjaSlider.listWIdth - ninjaSlider.holderWIdth) {
                ninjaSlider.listPos = ninjaSlider.listWIdth - ninjaSlider.holderWIdth;
            }

            ninjaSlider.listPos = ninjaSlider.listPos * -1;

            move(ninjaSlider.list, ninjaSlider.listPos, speed || ninjaSlider.settings.speed);

            // se indica el nuevo index
            ninjaSlider.currentIndex = to;
        },
        onMove: function onMove(ninjaSlider) {
            var isLeftBound = ninjaSlider.listPos >= 0 && ninjaSlider.delta.x > 0;
            var isRightBound = Math.abs(ninjaSlider.listPos) >= ninjaSlider.listWIdth - ninjaSlider.holderWIdth && ninjaSlider.delta.x < 0;
            var isInBounds = isLeftBound || isRightBound;

            // resistencia de arrastre en los bordes
            ninjaSlider.delta.x = ninjaSlider.delta.x / (isInBounds ? Math.abs(ninjaSlider.delta.x) / ninjaSlider.holderWIdth + 3 : 1);

            ninjaSlider.movementPos = ninjaSlider.delta.x + ninjaSlider.listPos;

            move(ninjaSlider.list, ninjaSlider.movementPos, 0);
        },
        onEnd: function onEnd(ninjaSlider, pointerCoors, targetIndex, event) {
            var isLeftBound = ninjaSlider.movementPos > 0;
            var isRightBound = Math.abs(ninjaSlider.movementPos) >= ninjaSlider.listWIdth - ninjaSlider.holderWIdth;

            // si es mayor a 0
            // borde izquierdo
            if (isLeftBound) {
                ninjaSlider.movementPos = 0;
            }

            // si es mayor al borde derecho
            else if (isRightBound) {
                    ninjaSlider.movementPos = (ninjaSlider.listWIdth - ninjaSlider.holderWIdth) * -1;
                }

                // en cualquier otro caso
                // la posicion final se iguala al offset del elemento mas cercano del Delta del movimiento
                else {
                        var positions = [];

                        ninjaSlider.items.forEach(function (item, i) {
                            positions.push(item.offsetLeft);
                        });

                        ninjaSlider.movementPos = closestNum(Math.abs(ninjaSlider.movementPos), positions) * -1;
                    }

            move(ninjaSlider.list, ninjaSlider.movementPos, ninjaSlider.settings.speed);
            ninjaSlider.listPos = ninjaSlider.movementPos;
        } });

})(window, document);
"use strict"; /*
               Sticky-kit v1.1.2 | WTFPL | Leaf Corcoran 2015 | http://leafo.net
              */
(function () {
    var b, f;
    b = window.jQuery;
    f = b(window);
    b.fn.stick_in_parent = function (d) {
        var A, w, J, n, B, K, p, q, k, E, t;
        null == d && (d = {});
        t = d.sticky_class;
        B = d.inner_scrolling;
        E = d.recalc_every;
        k = d.parent;
        q = d.offset_top;
        p = d.spacer;
        w = d.bottoming;
        null == q && (q = 0);
        null == k && (k = void 0);
        null == B && (B = !0);
        null == t && (t = "is_stuck");
        A = b(document);
        null == w && (w = !0);
        J = function J(a, d, n, C, F, u, r, G) {
            var v, _H, m, D, I, c, g, x, y, z, h, l;
            if (!a.data("sticky_kit")) {
                a.data("sticky_kit", !0);
                I = A.height();
                g = a.parent();
                null != k && (g = g.closest(k));
                if (!g.length) throw "failed to find stick parent";
                v = m = !1;
                (h = null != p ? p && a.closest(p) : b("<div />")) && h.css("position", a.css("position"));
                x = function x() {
                    var c, f, e;
                    if (!G && (I = A.height(), c = parseInt(g.css("border-top-width"), 10), f = parseInt(g.css("padding-top"), 10), d = parseInt(g.css("padding-bottom"), 10), n = g.offset().top + c + f, C = g.height(), m && (v = m = !1, null == p && (a.insertAfter(h), h.detach()), a.css({
                        position: "",
                        top: "",
                        width: "",
                        bottom: "" }).
                    removeClass(t), e = !0), F = a.offset().top - (parseInt(a.css("margin-top"), 10) || 0) - q,
                    u = a.outerHeight(!0), r = a.css("float"), h && h.css({
                        width: a.outerWidth(!0),
                        height: u,
                        display: a.css("display"),
                        "vertical-align": a.css("vertical-align"),
                        "float": r }),
                    e)) return l();
                };
                x();
                if (u !== C) return D = void 0, c = q, z = E, l = function l() {
                    var b, l, e, k;
                    if (!G && (e = !1, null != z && (--z, 0 >= z && (z = E, x(), e = !0)), e || A.height() === I || x(), e = f.scrollTop(), null != D && (l = e - D), D = e, m ? (w && (k = e + u + c > C + n, v && !k && (v = !1, a.css({
                        position: "fixed",
                        bottom: "",
                        top: c }).
                    trigger("sticky_kit:unbottom"))), e < F && (m = !1, c = q, null == p && ("left" !== r && "right" !== r || a.insertAfter(h),
                    h.detach()), b = {
                        position: "",
                        width: "",
                        top: "" },
                    a.css(b).removeClass(t).trigger("sticky_kit:unstick")), B && (b = f.height(), u + q > b && !v && (c -= l, c = Math.max(b - u, c), c = Math.min(q, c), m && a.css({
                        top: c + "px" })))) :
                    e > F && (m = !0, b = {
                        position: "fixed",
                        top: c },
                    b.width = "border-box" === a.css("box-sizing") ? a.outerWidth() + "px" : a.width() + "px", a.css(b).addClass(t), null == p && (a.after(h), "left" !== r && "right" !== r || h.append(a)), a.trigger("sticky_kit:stick")), m && w && (null == k && (k = e + u + c > C + n), !v && k))) return v = !0, "static" === g.css("position") && g.css({
                        position: "relative" }),

                    a.css({
                        position: "absolute",
                        bottom: d,
                        top: "auto" }).
                    trigger("sticky_kit:bottom");
                }, y = function y() {
                    x();
                    return l();
                }, _H = function H() {
                    G = !0;
                    f.off("touchmove", l);
                    f.off("scroll", l);
                    f.off("resize", y);
                    b(document.body).off("sticky_kit:recalc", y);
                    a.off("sticky_kit:detach", _H);
                    a.removeData("sticky_kit");
                    a.css({
                        position: "",
                        bottom: "",
                        top: "",
                        width: "" });

                    g.position("position", "");
                    if (m) return null == p && ("left" !== r && "right" !== r || a.insertAfter(h), h.remove()), a.removeClass(t);
                }, f.on("touchmove", l), f.on("scroll", l), f.on("resize",
                y), b(document.body).on("sticky_kit:recalc", y), a.on("sticky_kit:detach", _H), setTimeout(l, 0);
            }
        };
        n = 0;
        for (K = this.length; n < K; n++) {d = this[n], J(b(d));}
        return this;
    };
})(window, document, jQuery);
'use strict';var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};(function (window, document) {
    "use strict";

    // merges objects and overrides properties of the target object
    var extend = function extend(target, source) {
        var a = Object.create(target);
        Object.keys(source).map(function (prop) {
            prop in a && (a[prop] = source[prop]);
        });
        return a;
    };

    // test if a given element matches a css selector
    var matchesSelector = function matchesSelector(selector, element) {
        var matches = (element.document || element.ownerDocument).querySelectorAll(selector);
        var i = 0;

        while (matches[i] && matches[i] !== element) {
            i++;
        }

        return matches[i] ? true : false;
    };

    // vanilla similar of jQuery.on()
    // multiple arguments model
    // v1 : events (String), element (node), callback (function) ---- directly delegates callback
    // v2 : events (String), element (node), data (object), callback (function) ---- directly delegates callback
    // v3 : events (String), element (node), selector (string), data (object), callback (function) ---- delegates event to one parent
    var on = function on() {
        if (!arguments || !arguments.length) {return;}

        var events = arguments[0],
        element = arguments[1],
        data = {},
        childrenSelectors,callback;

        if (_typeof(arguments[2]) === 'object') {
            data = arguments[2];
            callback = arguments[3];
        } else
        if (typeof arguments[2] === 'function') {
            callback = arguments[2];
        } else
        if (typeof arguments[2] === 'string') {
            childrenSelectors = arguments[2];

            if (_typeof(arguments[3]) === 'object') {
                data = arguments[3];
                callback = arguments[4];
            } else
            if (typeof arguments[3] === 'function') {
                callback = arguments[3];
            }
        }

        events.split(' ').forEach(function (ev) {
            element.addEventListener(ev, function (event) {
                event.data = data;

                if (childrenSelectors && event.target && matchesSelector(childrenSelectors, event.target)) {
                    callback.bind(event.target)(event);
                } else {
                    callback.bind(element)(event);
                }
            }, false);
        });
    };

    var toRealArray = function toRealArray(arrayLike) {
        return arrayLike ? Array.prototype.map.call(arrayLike, function (v) {return v;}) : [];
    };

    window.Validizr = function (form, options) {
        if (!form) {return;} // safety first

        // create the defaults and allow for custom options
        this.defaults = {
            validateOnInit: false, // bool, activa/desactiva la validacion en la inicializacion
            delegate_change: true, // bool, controla la delegacion de la validacion en los campos
            delegate_keyup: true, // bool, controla la delegacion de la validacion en los campos

            onInit: undefined, // callback para despues de la inicialiacion del plugin

            validFormCallback: undefined, // funcion, lleva como parametro el $formulario
            notValidFormCallBack: undefined, // funcion, lleva como parametro el $formulario

            validInputCallback: undefined, // funcion, lleva como parametro el $input
            notValidInputCallback: undefined, // funcion, lleva como parametro el $input

            preValidation: undefined, // funcion, lleva como parametro el $formulario y el $input
            postValidation: undefined, // funcion, lleva como parametro el $formulario y el $input

            notValidClass: 'invalid-input', // string, clase a aplicar a los inputs no validos
            validClass: 'valid-input', // string, clase a aplicar a los inputs no validos

            aditionalInputs: undefined, // string, selector para inputs customizados

            customValidations: {}, // objeto, prototipo para las validaciones customizadas. 
            customValidHandlers: {}, // objeto, prototipo para los exitos customizados. 
            customErrorHandlers: {} // objeto, prototipo para los errores customizados. 
        };
        this.settings = extend(this.defaults, options || {});

        // identify the form element
        if (typeof form === 'string') {
            this.form = document.querySelector(form);
        } else
        if (form.nodeType) {
            this.form = form;
        }

        // this.emailRegEx = /[\w\d-_.]+@[\w\d-_.]+\.[\w]{2,10}$/;
        this.emailRegEx = /@/;
        this.urlRegEx = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;

        // cache selectors
        this.inputs_selector = 'input:not([type="submit"]):not([type="reset"]), select, textarea';
        if (this.settings.aditionalInputs) {
            this.inputs_selector += ' ' + this.settings.aditionalInputs;
        }

        // disable html5 validation
        this.form.noValidate = true;
        this.form.dataset.validizrHandled = true;

        // delegate events
        var events = 'validizrValidate';
        if (this.settings.delegate_change) {events += ' change';}
        if (this.settings.delegate_keyup) {events += ' keyup';}

        on(events, this.form, this.inputs_selector, { validizr: this }, this.validateInputs);
        on('submit', this.form, { validizr: this }, this.validateForm);

        // trigger validation on init if set
        if (this.settings.validateOnInit) {
            this.validate();
        }

        // fire init callback if exist
        if (typeof this.settings.onInit === 'function') {
            this.settings.onInit(this.form, this);
        }

        // return plain object with useful functions
        return {
            validate: this.validate.bind(this),
            getStatus: this.getStatus.bind(this) };

    };
    window.Validizr.prototype = {
        validateInputs: function validateInputs(event) {
            var input = this,
            validizr = event.data.validizr,
            inputType = validizr.getInputType(input),
            customHandler = input.getAttribute('data-custom-validation'),
            value = input.value,
            validInput = function () {
                var isRequired = input.required || typeof input.getAttribute('required') !== 'undefined';
                if (!isRequired && !input.classList.contains('required')) {return true;}
                if (!!customHandler && typeof validizr.settings.customValidations[customHandler] === 'function') {
                    return validizr.settings.customValidations[customHandler](input, validizr, event);
                }
                switch (inputType) {
                    case 'email':return !!value && validizr.emailRegEx.test(value);
                    case 'url':return !!value && validizr.urlRegEx.test(value);
                    case 'checkbox':return input.checked;
                    default:return !!value;}

            }();

            if (input.classList.contains(validizr.settings.notValidClass) || input.classList.contains(validizr.settings.validClass)) {
                input.classList.remove(validizr.settings.notValidClass);
                input.classList.remove(validizr.settings.validClass);
            }

            if (typeof validizr.settings.preValidation === 'function') {validizr.settings.preValidation(validizr.form, input);}

            validizr.youAre(validInput, input);

            if (typeof validizr.settings.postValidation === 'function') {validizr.settings.postValidation(validizr.form, input);}
        },
        validateForm: function validateForm(event) {
            var validizr = event.data.validizr,
            isValid = false;

            validizr.validate();
            isValid = validizr.isFormValid();

            if (isValid) {
                if (typeof validizr.settings.validFormCallback === 'function') {
                    event.preventDefault();
                    validizr.settings.validFormCallback(validizr.form);
                    if (validizr.form.dataset.nativeSubmit) {
                        return true;
                    }
                    return false;
                }
                return true;
            } else
            if (typeof validizr.settings.notValidFormCallBack === 'function') {
                validizr.settings.notValidFormCallBack(validizr.form);
            }

            event.preventDefault();
            return false;
        },
        isFormValid: function isFormValid() {
            var fields = toRealArray(this.form.querySelectorAll(this.inputs_selector)),
            totalLength = fields.length,
            validLength = fields.filter(function (input) {return input.dataset.validizrValidity;}).length,
            softValidation = toRealArray(this.form.querySelectorAll('.' + this.settings.notValidClass)).length;
            return totalLength === validLength && !softValidation;
        },
        youAre: function youAre(validity, input) {
            var customHandler_invalid = input.getAttribute('data-custom-invalid-callback'),
            customHandler_valid = input.getAttribute('data-custom-valid-callback');

            input.dataset.validizrValidity = validity;

            if (validity) {
                input.classList.add(this.settings.validClass);

                if (typeof this.settings.customValidHandlers[customHandler_valid] === 'function') {
                    this.settings.customValidHandlers[customHandler_valid](input);
                }
                if (typeof this.settings.validInputCallback === 'function') {
                    this.settings.validInputCallback(input);
                }
            } else {
                input.classList.add(this.settings.notValidClass);

                if (typeof this.settings.customErrorHandlers[customHandler_invalid] === 'function') {
                    this.settings.customErrorHandlers[customHandler_invalid](input);
                }
                if (typeof this.settings.notValidInputCallback === 'function') {
                    this.settings.notValidInputCallback(input);
                }
            }
        },
        getInputType: function getInputType(input) {
            return input.type ? input.type.toLowerCase() : input.tagName.toLowerCase();
        },
        validate: function validate(selector) {
            var inputs = toRealArray(this.form.querySelectorAll(selector || this.inputs_selector));
            inputs.forEach(function (input) {
                var validation_event = document.createEvent("Event");
                validation_event.initEvent("validizrValidate", true, true);
                input.dispatchEvent(validation_event);
            });

            return this.getStatus();
        },
        getStatus: function getStatus() {
            var fields = toRealArray(this.form.querySelectorAll(this.inputs_selector));
            return {
                validity: this.isFormValid(),
                invalidInputs: fields.filter(function (input) {return !input.dataset.validizrValidity;}),
                validInputs: fields.filter(function (input) {return input.dataset.validizrValidity;}) };

        } };

})(window, document);
'use strict'; //////////////////////
////////////////////// Common Carousel
//////////////////////
(function (window, document, $) {
	"use strict";

	// check for NinjaSlider dependency
	if (typeof NinjaSlider === 'undefined') {
		console.log('Error: NinjaSlider is required');
		return;
	}

	var CommonCarousel = function CommonCarousel(element) {
		this.container = element;
		this.$container = $(element);
		this.$slides = this.$container.find('[data-role="carousel-slide"]');
		this.$arrows = this.$container.find('[data-role="carousel-arrow"]');

		this.ninjaSlider = new NinjaSlider(this.container, {
			auto: false,
			effect: 'carousel',
			itemsConf: this.parseOptions() });


		this.$arrows.on('click.CommonCarousel', this.arrowCallback.bind(this));
	};
	CommonCarousel.prototype = {
		arrowCallback: function arrowCallback(event) {
			event.preventDefault();
			var $btn = $(event.currentTarget),
			direction = $btn.data('direction');
			this.ninjaSlider[direction]();
		},

		parseOptions: function parseOptions() {
			var itemsConf = {},
			mqitems = [];

			itemsConf.base = this.$container.data('maxitems') && parseFloat(this.$container.data('maxitems')) || 5;

			if (this.$container.data('mqitems')) {
				this.$container.data('mqitems').split('|').forEach(function (textInfo) {
					var data = textInfo.split(',');
					mqitems.push([data[0], parseFloat(data[1])]);
				});

				itemsConf.medias = mqitems;
			}

			return itemsConf;
		} };


	$.fn.commonCarousel = function () {
		if (this.data('commonCarousel')) {return this.data('commonCarousel');}
		return this.each(function (i, el) {
			$(el).data('commonCarousel', new CommonCarousel(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="carousel"]').commonCarousel();
	});

})(window, document, jQuery);
'use strict'; /******************
              MIT License
              
              Copyright (c) 2016 Fernando Silva Müller (@fdograph)
              
              Permission is hereby granted, free of charge, to any person obtaining a copy
              of this software and associated documentation files (the "Software"), to deal
              in the Software without restriction, including without limitation the rights
              to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              copies of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:
              
              The above copyright notice and this permission notice shall be included in all
              copies or substantial portions of the Software.
              
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              SOFTWARE.
              
              Chilean RUT validator written in VanillaJS
              ******************/
(function (window, document) {
	"use strict";

	var NinjaRut = function NinjaRut(protoRut) {
		this.protoRut = protoRut;
		this.cleanRut = this.clean();
		this.process();
		return this;
	};
	NinjaRut.prototype = {
		clean: function clean() {
			var allowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'k'];

			// clean the proto rut by removing forbidden characters
			var clean = Array.prototype.map.call(this.protoRut.toLowerCase(), function (c) {return c;});
			clean = clean.filter(function (c) {
				return allowed.indexOf(c) !== -1;
			});

			return clean.join('');
		},

		process: function process() {
			this.number = this.cleanRut.substring(0, this.cleanRut.length - 1);
			this.digit = this.cleanRut.charAt(this.cleanRut.length - 1);
			this.isValid = this.validate();
		},

		getDigit: function getDigit() {
			var sum = 0,
			mul = 2,
			res;

			var i = this.number.length;

			while (i--) {
				sum = sum + parseInt(this.number.charAt(i)) * mul;
				if (mul % 7 === 0) {mul = 2;} else
				{mul++;}
			}

			res = sum % 11;
			if (res === 0) {return '0';} else
			if (res === 1) {return 'k';} else
			{return 11 - res;}
		},

		validate: function validate() {
			// if too short
			if (this.cleanRut.length < 6) {
				return false;
			}

			// if impossible ruts(but valid tho)
			// Eg: 11111111-1
			if (this.cleanRut.match(/(\d)\1{7,9}/)) {
				return false;
			}

			// math validation
			if (this.digit != this.getDigit()) {
				return false;
			}

			return true;
		},

		format: function format(dots) {
			var formatedNum = dots ? this.number.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : this.number;
			return formatedNum + '-' + this.digit;
		} };


	window.NinjaRut = NinjaRut;
})(window, document);

(function (window, document, $) {
	"use strict";

	// check for Validizr dependency
	if (typeof Validizr === 'undefined') {
		console.log('Error: Validizr is required');
		return;
	}

	/////////////////////////////////////////
	///////////////////////////////////////// CommonForm Module
	/////////////////////////////////////////

	var CommonForm = function CommonForm(form) {
		this.form = form;
		this.validizr = new Validizr(this.form, {
			validInputCallback: this.validInputAction,
			notValidInputCallback: this.invalidInputAction,
			customValidations: this.customValidations,
			validFormCallback: this.validFormCallback });


		return this;
	};
	CommonForm.prototype = {
		validInputAction: function validInputAction(input) {
			$(input).siblings('.form-control__text').show(); //added
			$(input).parents('.form-control').removeClass('form-control--invalid');
		},
		invalidInputAction: function invalidInputAction(input) {
			$(input).siblings('.form-control__text').hide(); //added
			$(input).parents('.form-control').addClass('form-control--invalid');
		},
		validFormCallback: function validFormCallback(form) {
			if ($(form).data('function'))
			eval('$.' + $(form).data('function') + '()');
		},
		customValidations: {
			onlyNumbers: function onlyNumbers(input, validizr, event) {
				var $input = $(input),
				value = $input.val(),
				cleanValue = value.replace(/\D/g, ''),
				minLength = $input.data('minlength') || false,
				maxLength = $input.data('maxlength') || false;

				// force clean value to input
				$input.val(cleanValue);

				// only act on required fields
				// if no value and not required
				if (!cleanValue && !$input.prop('required')) {return true;}

				// value validation

				// if no value after cleaning
				if (!cleanValue) {return false;}

				// if less than specified minimun length
				if (minLength && cleanValue.length < minLength) {return false;}

				// if more than specified maximum length
				if (maxLength && cleanValue.length > maxLength) {return false;}

				// return value based boolean
				return !!cleanValue;
			},

			onlyString: function onlyString(input, validizr, event) {
				var $input = $(input),
				value = $input.val(),
				cleanValue = value.replace(/\d/g, ''),
				minLength = $input.data('minlength') || false,
				maxLength = $input.data('maxlength') || false;

				// force clean value to input
				$input.val(cleanValue);

				// only act on required fields
				// if no value and not required
				if (!cleanValue && !$input.prop('required')) {return true;}

				// value validation

				// if no value after cleaning
				if (!cleanValue) {return false;}

				// if less than specified minimun length
				if (minLength && cleanValue.length < minLength) {return false;}

				// if more than specified maximum length
				if (maxLength && cleanValue.length > maxLength) {return false;}

				// return value based boolean
				return !!cleanValue;
			},

			equalTo: function equalTo(input, validizr, event) {
				var $input = $(input),
				inputType = validizr.getInputType(input),
				value = $input.val(),
				sample = $('#' + $input.data('sample')).val();

				// value validation

				// check if any is empty
				if (!value || !sample) {return false;}

				// check if is email depending on input type
				if (inputType === 'email') {
					//if email input and any of the values isnt an email
					if (!validizr.emailRegEx.test(value) || !validizr.emailRegEx.test(sample)) {
						return false;
					}
				}

				// check if both values are equal
				if (value !== sample) {return false;}

				// return value based boolean
				return !!value;
			},

			matchPattern: function matchPattern(input, validizr, event) {
				var $input = $(input),
				value = $input.val(),
				protoPattern = $input.data('pattern'),
				pattern = new RegExp(protoPattern);

				// value validation

				// if no value
				if (!value) {return false;}

				// return regexp based boolean
				return pattern.test(value);
			},

			validRut: function validRut(input, validizr, event) {
				var $input = $(input),
				rut = new NinjaRut($input.val().trim());

				// value validation
				if (!rut.isValid) {return false;}

				// if autoformat is specified
				if ($input.data('autoformat')) {
					$input.val(rut.format(true));
				}

				// if it passes is considered valid
				return true;
			} } };




	$.fn.commonForm = function () {
		if (this.data('commonForm')) {return this.data('commonForm');}
		return this.each(function (i, el) {
			$(el).data('commonForm', new CommonForm(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="common-form"]').commonForm();
	});
})(window, document, jQuery);
'use strict';$(document).ready(function () {
    $('[data-module="collapse-body"]').hide();
    $('[data-action="collapse-deploy"]').click(function () {
        $(this).siblings('[data-module="collapse-body"]').slideToggle();
        $(this).children('.icon-elem').toggleClass('animate');
    });

    $('[data-action="search-deployer"]').on('click', function () {
        $('[data-module="search-deploy"]').delay(4000).toggleClass('active');
        $(this).toggleClass('inactive').toggleClass('icon-elem--search').toggleClass('icon-elem--close');
    });

    $('[data-action="sidebar-deployer"]').on('click', function () {
        $('[data-module="sidebar-body"]').delay(4000).toggleClass('deployed');
    });

    $('[data-module="max-counter"]').keyup(function () {
        var $textarea = $(this),
        maxlength = parseInt($textarea.attr('maxlength')),
        valuelength = $textarea.val().length;

        $('#max-dead').text(maxlength - valuelength);
    });
    if (Modernizr.mq('(max-width: 480px)')) {
        $('.step-box__button').removeClass('tablet-up').addClass('tablet-down');
    } else {
        $('.step-box__button').removeClass('tablet-down').addClass('tablet-up');
    }

    var lastId,
    topMenu = $(".sidebar__indice"),
    topMenuHeight = topMenu.outerHeight(),
    // All list items
    menuItems = topMenu.find("a"),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function () {
        var item = $($(this).attr("href"));
        if (item.length) {return item;}
    });

    $(window).scroll(function () {
        // Get container scroll position
        var fromTop = $(this).scrollTop() + topMenuHeight;

        // Get id of current scroll item
        var cur = scrollItems.map(function () {
            if ($(this).offset().top < fromTop)
            return this;
        });
        // Get the id of the current element
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";

        if (lastId !== id) {
            lastId = id;
            // Set/remove active class
            menuItems.
            parent().removeClass("sidebar__item--current").
            end().filter("[href='#" + id + "']").parent().addClass("sidebar__item--current");
        }
    });

    $('[data-module="audio-js"]').audio();
    $('[data-module="stickyParent"]').stick_in_parent();
});
'use strict';(function (window, document, $) {
	"use strict";

	var Message = function Message(element) {
		this.$element = $(element);
		this.$element.find('[data-role="close"]').on('click', this.close.bind(this));

		return this;
	};
	Message.prototype = {
		close: function close(event) {
			event.preventDefault();
			this.$element.slideUp({
				duration: 250,
				progress: function progress(promise, _progress, remainingTime) {
					var percent = 1 - _progress;
					$(this).css('opacity', percent);
				},
				complete: function complete() {
					$(this).remove();
				} });

		} };



	$.fn.message = function () {
		if (this.data('message')) {return this.data('message');}
		return this.each(function (i, el) {
			$(el).data('message', new Message(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="message"]').message();
	});
})(window, document, jQuery);
'use strict';(function (window, document, $) {
	"use strict";

	var Modal = function Modal(element) {
		this.$element = $(element);
		this.target = this.$element.data('target');
		this.method = this.$element.data('method') || 'GET';
		this.query = this.$element.data('query') || {};

		this.$element.on('click.modal', this.open.bind(this));
		return this;
	};
	Modal.prototype = {
		close: function close(event) {
			event.preventDefault();
			var $modal = $(event.currentTarget).parents('.modal');
			$modal.fadeIn({
				duration: 200, //chng
				complete: function complete() {$modal.remove();} });

		},
		open: function open(event) {
			event.preventDefault();

			var $element = this.$element;

			$element.trigger('modal.preopen', [this]);

			var lb_promise = this.showLightbox(),
			ajax_promise = $.ajax({
				url: this.target,
				method: this.method,
				data: this.query });


			$.when(lb_promise, ajax_promise).then(function (lb, ajax_res) {
				var $modal = lb,
				response = ajax_res[0];

				$modal.html(response);
				$modal.addClass('loaded');
				$element.trigger('modal.complete', [$modal, response]);
			});
		},

		showLightbox: function showLightbox() {
			var promise = new $.Deferred(),
			$modal = $('<div class="modal"><div class="modal__body" data-role="modal-body"><button data-role="modal-btn" class="modal__button"></button><div data-role="modal-content" class="modal__content"></div></div></div>');

			$modal.find('[data-role="modal-btn"]').on('click.modal', this.close.bind(this));
			$('body').append($modal);

			$modal.addClass('modal--loaded');

			// RESOLVE SEGUN DISPONIBILIDAD
			var ended = false;
			$modal.on('transitionend', function () {
				ended = true;
				promise.resolve($modal.find('[data-role="modal-content"]'));
			});

			setTimeout(function () {
				if (!ended) {
					ended = true;
					promise.resolve($modal.find('[data-role="modal-content"]'));
				}
			}, 800);


			return promise;
		} };



	$.fn.modal = function () {
		if (this.data('modal')) {return this.data('modal');}
		return this.each(function (i, el) {
			$(el).data('modal', new Modal(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="modal"]').modal();
	});
})(window, document, jQuery);
'use strict';var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};(function (window, document, $) {
	"use strict";

	var Breakpoints = {
		extra_small: '20em',
		small: '40em',
		medium: '50em',
		large: '64em',
		extra_large: '80em',
		huge: '90em' };


	var unique = function unique(arr) {
		var unique = [],i;

		for (i = 0; i < arr.length; i++) {
			var current = arr[i];
			if (unique.indexOf(current) < 0) {unique.push(current);}
		}
		return unique;
	};


	var MQChange = function MQChange() {
		if (typeof window.matchMedia === 'undefined') {
			console.log('Error: Window.matchMedia or polyfill is required');
			return;
		}

		this.setMedias();
	};

	MQChange.prototype = {
		registerMedia: function registerMedia(query, actions) {
			var registered_mq = window.matchMedia(query);
			var mq_actions = function mq_actions(mql) {
				// react to media query match
				if (mql.matches && typeof actions.match === 'function') {
					actions.match();
				}

				// react to media query unmatch
				else if (!mql.matches && typeof actions.unmatch === 'function') {
						actions.unmatch();
					}
			};

			if ((typeof actions === 'undefined' ? 'undefined' : _typeof(actions)) === 'object') {
				registered_mq.addListener(mq_actions);
				mq_actions(registered_mq);
			}
		},

		setMedias: function setMedias() {
			var app = this;
			var $changeables = $('[data-mq-change]');

			for (var mqName in Breakpoints) {
				// closure para manejar la variable
				(function (mq_slug) {
					app.registerMedia('screen and (max-width: ' + Breakpoints[mq_slug] + ')', {
						match: function match() {
							app.moveElements($changeables.filter('[data-mq-change="' + mq_slug + '"]'), 'match');
						},
						unmatch: function unmatch() {
							app.moveElements($changeables.filter('[data-mq-change="' + mq_slug + '"]'), 'unmatch');
						} });

				})(mqName);
			}
		},

		moveElements: function moveElements($set, type) {
			var areaType = 'data-' + type + '-area',
			groups = $set.groupByAtt(areaType);

			groups.forEach(function ($group) {
				var $target = $('[data-area-name="' + $group.first().attr(areaType) + '"]');

				$group.sort(function (a, b) {
					return $(a).data('order') - $(b).data('order');
				});

				$group.appendTo($target);
			});
		} };



	$.fn.groupByAtt = function (attname) {
		var $set = this,
		groups = [],
		posibles = [];

		// se guardan todos los posibles valores
		$set.each(function (i, el) {
			posibles.push(el.getAttribute(attname));
		});

		// se quitan los elementos duplicados dejando solo los unicos
		posibles = unique(posibles);

		// se itera sobre las posibilidades y se agrupan los elementos
		posibles.forEach(function (value) {
			groups.push($set.filter('[' + attname + '="' + value + '"]'));
		});

		return groups;
	};

	// self initialization
	$(document).ready(function () {
		var changeable = new MQChange();
	});

})(window, document, jQuery);
'use strict';(function (window, document, $) {
	"use strict";

	var NavBar = function NavBar(element) {
		this.$navBar = $(element);
		this.$navBarBody = this.$navBar.find('[data-role="nav-body"]');
		this.$navBarDeployer = this.$navBar.find('[data-role="nav-deployer"]');
		this.$navBarDeployer.on('click.NavBar', this.toggleNavBar.bind(this));
		this.touchSubmenus();

		return this;
	};

	NavBar.prototype = {
		toggleNavBar: function toggleNavBar(event) {
			event.preventDefault();
			this.$navBarDeployer.toggleClass('deployed');
			this.$navBarBody.toggleClass('deployed');
		},

		touchSubmenus: function touchSubmenus() {
			if (!Modernizr.touchevents) {return;}

			var $touchSubmenus = $('body').find('[data-role="touch-submenu"]');
			$touchSubmenus.on('click.touchSubmenus', '[data-role="touch-submenu-deployer"]', function (e) {
				event.preventDefault();
				console.log('lala');
				$(e.currentTarget).parent().toggleClass('deployed');
			});
		} };



	$.fn.navBar = function () {
		if (this.data('navBar')) {return this.data('navBar');}
		return this.each(function (i, el) {
			$(el).data('navBar', new NavBar(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="nav-bar"]').navBar();
	});

})(window, document, jQuery);
'use strict'; //////////////////////
////////////////////// Common Slider
//////////////////////
(function (window, document, $) {
	"use strict";

	// check for NinjaSlider dependency
	if (typeof NinjaSlider === 'undefined') {
		console.log('Error: NinjaSlider is required');
		return;
	}

	var CommonSlider = function CommonSlider(element) {
		this.container = element;
		this.$container = $(element);
		this.$slides = this.$container.find('[data-role="slider-slide"]');
		this.$arrows = this.$container.find('[data-role="slider-arrow"]');
		this.$bullets = this.$container.find('[data-role="slider-bullet"]');
		this.$thumbnails = this.$container.find('[data-role="slider-thumbnail"]');
		this.$footers = this.$container.find('[data-role="slider-footing"]');
		this.$transition = this.$container.data('transition') || false;
		this.$speed = this.$container.data('speed') || 400;
		this.$autotime = 2000;

		if (typeof this.$transition !== 'undefined') {
			this.$autotime = this.$transition;
		}

		this.ninjaSlider = new NinjaSlider(this.container, {
			auto: this.$autotime,
			speed: this.$speed,
			transitionCallback: this.transitionCallback.bind(this) });


		this.$arrows.on('click.CommonSlider', this.arrowCallback.bind(this));
		this.$bullets.on('click.CommonSlider', this.bulletCallback.bind(this));
		this.$thumbnails.on('click.CommonSlider', this.bulletCallback.bind(this));
	};
	CommonSlider.prototype = {
		transitionCallback: function transitionCallback(index, slide, ninjaSlider) {
			if (this.$bullets.length) {
				this.$bullets.removeClass('slider__bullet--current');
				this.$bullets.filter('[data-target="' + index + '"]').addClass('slider__bullet--current');
			}

			if (this.$thumbnails.length) {
				this.$thumbnails.removeClass('slider__thumbnail--current');
				this.$thumbnails.filter('[data-target="' + index + '"]').addClass('slider__thumbnail--current');
			}

			if (this.$footers.length) {
				this.$footers.removeClass('slider__foot--current');
				this.$footers.filter('[data-target="' + index + '"]').addClass('slider__foot--current');
			}
		},

		arrowCallback: function arrowCallback(event) {
			event.preventDefault();
			var $btn = $(event.currentTarget),
			direction = $btn.data('direction');
			this.ninjaSlider[direction]();
		},

		bulletCallback: function bulletCallback(event) {
			event.preventDefault();
			var $btn = $(event.currentTarget),
			target = $btn.data('target');

			this.ninjaSlider.slide(target);
		} };


	$.fn.commonSlider = function () {
		if (this.data('commonSlider')) {return this.data('commonSlider');}
		return this.each(function (i, el) {
			$(el).data('commonSlider', new CommonSlider(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="slider"]').commonSlider();

		console.log('open slider');
	});
})(window, document, jQuery);
'use strict';(function (window, document, $) {
    "use strict";

    var AudioPlay = function AudioPlay(element) {
        this.$audio = $(element);
        this.$audioElement = document.createElement('audio');

        this.$audiosrc = this.$audio.data('target');
        this.$audioElement.setAttribute('src', this.$audiosrc);

        this.$playbutton = this.$audio.find('[data-role="button-play"]');
        this.$pausebutton = this.$audio.find('[data-role="button-pause"]');
        this.$playbutton.on('click', this.playAudio.bind(this));
        this.$pausebutton.on('click', this.pauseAudio.bind(this));
        return this;
    };

    AudioPlay.prototype = {
        playAudio: function playAudio(event) {
            event.preventDefault();
            this.$audioElement.play();
            this.$playbutton.toggleClass('remove');
            this.$pausebutton.toggleClass('remove');
        },
        pauseAudio: function pauseAudio(event) {
            event.preventDefault();
            this.$audioElement.pause();
            this.$pausebutton.toggleClass('remove');
            this.$playbutton.toggleClass('remove');
        } };


    $.fn.audio = function () {
        if (this.data('audio')) {return this.data('audio');}
        return this.each(function (i, el) {
            $(el).data('audio', new AudioPlay(el));
        });
    };

})(window, document, jQuery);
'use strict';(function (window, document, $) {
    "use strict";

    var DEBUG = true;

    var $window = $(window),
    $document = $(document),
    $body = $('body');

    /// guardo los media queries
    var TABLETS_DOWN = 'screen and (max-width: 1024px)',
    VERTICAL_TABLETS_DOWN = 'screen and (max-width: 768px)',
    PHABLETS_DOWN = 'screen and (max-width: 640px)';

    var throttle = function throttle(fn) {
        return setTimeout(fn, 1);
    };

    var App = function App() {
        this.path = $('body').attr("data-path");
        this.ajaxURL = '/wp-admin/admin-ajax.php';
        this.loadLegacyAssets();

        var app = this;
    };

    App.prototype = {
        onReady: function onReady() {
            this.setGlobals();
            this.autoHandleEvents($('[data-func]'));
            this.handleMobileTables();
            this.conditionalInits();
            throttle(this.setFixedHeader);

            $('a, button, input[type="submit"]').on('touchstart', $.noop);
        },

        onLoad: function onLoad() {
            if ($('[data-role="scroll-navigation"]').length) {
                this.scrollNavigation($('[data-role="scroll-navigation"]'));
            }
        },

        onResize: function onResize() {
            throttle(this.setFixedHeader);
        },

        loadLegacyAssets: function loadLegacyAssets() {
            // voy a asumir que cualquier browser que no soporte <canvas> es un oldIE (IE8-)
            if (Modernizr.canvas) {return false;}

            Modernizr.load({
                load: this.path + 'scripts/support/selectivizr.min.js' });

        },

        autoHandleEvents: function autoHandleEvents($elements) {
            if (!$elements || !$elements.length) {return false;}

            var self = this;

            $elements.each(function (i, el) {
                var func = el.getAttribute('data-func') || false,
                evts = el.getAttribute('data-events') || 'click.customStuff';

                if (func && typeof self[func] === 'function') {
                    $(el).
                    off(evts).
                    on(evts, $.proxy(self[func], self)).
                    attr('data-delegated', 'true');
                }
            });
        },

        conditionalInits: function conditionalInits() {

            // // modulo  mosaicos en home
            if ($('[data-role="mosaic3d"]').length) {
                this.mosaic3d($('[data-role="mosaic3d"]'));
            }

            /// Se activa cuando hay un hash y me encuentro en las plantillas de single curso.
            if ($body.hasClass('page-template-curso') && window.location.hash) {
                // activamos de inmediato el tab correspondiente
                var tab_hash = window.location.hash.substr(1);
                $('[data-func="tabControl"][data-target="' + tab_hash + '"]').trigger('click');
            }
        },

        setGlobals: function setGlobals() {
            $body = $('body');
        },

        ///////////////////////////////////////////////////////////
        /////////////////////////////// Auxiliares
        ///////////////////////////////////////////////////////////
        debug: function debug(message) {
            DEBUG && console.log(message);
        },

        moveElements: function moveElements($set, type) {
            var areaType = 'data-' + type + '-area',
            groups = $set.groupByAtt(areaType);

            groups.forEach(function ($group) {
                var $target = $('[data-area-name="' + $group.first().attr(areaType) + '"]');

                $group.sort(function (a, b) {
                    return $(a).data('order') - $(b).data('order');
                });

                $group.appendTo($target);
            });
        },

        mapSectionsPositions: function mapSectionsPositions($items) {
            var map = [];
            $items.each(function (index, el) {
                var $el = $(el),
                $target = $($el.attr('href')),
                targetOffset = $target.offset();

                targetOffset.bottom = targetOffset.top + $target.height();

                map.push({
                    $item: $el,
                    offset: targetOffset,
                    selector: $el.attr('href') });

            });

            return map;
        },

        // setFixedHeader : function(){
        //     if( Modernizr.mq(VERTICAL_TABLETS_DOWN) ){
        //         var headerHeight = document.querySelector('#main-header').offsetHeight;
        //         document.body.style.marginTop = headerHeight + 14 + 'px';
        //     }
        //     else {
        //         document.body.style.marginTop = 0;
        //     }
        // },

        blockScroll: function blockScroll(event) {
            event.stopPropagation();
        },


        ///////////////////////////////////////////////////////////
        /////////////////////////////// Generales
        ///////////////////////////////////////////////////////////

        handleMobileTables: function handleMobileTables() {
            $('.regular-content-area table').each(function (i, table) {
                $(table).wrap('<div class="regular-content-table-holder"></div>');
            });
        },

        setLightBox: function setLightBox(classes) {
            /// se crean los elementos
            var $bg = $('<div />').attr({ id: 'lightbox-background', class: 'lightbox-background' }),
            $scrollable = $('<div />').attr({ class: 'lightbox-scrollable-holder' }),
            $holder = $('<div />').attr({ class: 'lighbox-holder' }).append('<div class="lightbox-close-holder"></div>'),
            $content = $('<div />').attr({ class: 'lightbox-content' }),
            $closeBtn = $('<button class="primary-btn small-btn icon-btn--close-lb" >Cerrar</button>');

            // se inicia la promesa
            var promise = new $.Deferred();

            if (classes) {
                $holder.addClass(classes);
            }

            $closeBtn.on('click', this.closeLightBox);
            $window.on('keyup.lightbox', this.closeLightBox);

            $holder.appendTo($scrollable).find('.lightbox-close-holder').append($closeBtn);

            $body.append($bg);

            $bg.animate({ opacity: 1 }).promise().then(function () {
                $body.css('overflow', 'hidden');
                $bg.append($scrollable);
                $holder.append($content);
                promise.resolve($bg, $content);
            });

            return promise;
        },

        closeLightBox: function closeLightBox(e) {
            if (e.type === 'click' || e.type === 'keyup' && e.keyCode == 27) {
                $('#lightbox-background').remove();
                $body.css('overflow', 'auto');
                $window.off('keyup.lightbox keyup.singleSlider');
            }
        },

        ///////////////////////////////////////////////////////////
        /////////////////////////////// Modulos
        ///////////////////////////////////////////////////////////

        scrollNavigation: function scrollNavigation($nav) {
            var app = this,
            $navItems = $nav.children(),
            locationsMap = this.mapSectionsPositions($navItems);

            $window.on('resize.ScrollNav', function () {
                locationsMap = app.mapSectionsPositions($navItems);
            });

            $window.on('scroll.ScrollNav', function () {
                var scrollPosition = $window.scrollTop();

                locationsMap.forEach(function (item_info) {
                    if (scrollPosition > item_info.offset.top - 100) {
                        $navItems.removeClass('active');
                        item_info.$item.addClass('active');
                    }
                });
            });
        },

        getShareCount: function getShareCount($elements) {
            // se setea el api de google plus primero
            // api key publico
            // if( typeof gapi !== 'undefined' ){
            //     gapi.client.setApiKey('AIzaSyCKSbrvQasunBoV16zDH9R33D88CeLr9gQ');
            // }

            $elements.each(function (index, element) {
                var type = element.getAttribute('data-type'),
                url = element.getAttribute('data-url'),
                jsonUrl = '',
                data = {};

                var params = {
                    nolog: true,
                    id: url,
                    source: "widget",
                    userId: "@viewer",
                    groupId: "@self" };


                if (type === 'facebook') {
                    jsonUrl = 'http://graph.facebook.com/';
                    data.id = url;
                } else
                if (type === 'twitter') {
                    // Url obsoleta.
                    //jsonUrl = 'http://urls.api.twitter.com/1/urls/count.json';
                    //data.url = url;
                    return;
                } else
                if (type === 'linkedin') {
                    jsonUrl = 'http://www.linkedin.com/countserv/count/share';
                    data.format = 'jsonp';
                    data.url = url;
                } else
                {
                    // gapi.client.rpcRequest('pos.plusones.get', 'v1', params).execute(function(resp) {
                    //     console.log('count:', resp.result.metadata.globalCounts.count);
                    // });
                }

                $.ajax({
                    method: 'GET',
                    url: jsonUrl,
                    data: data,
                    dataType: 'jsonp' }).
                then(function (response) {
                    var count = '';

                    // se saca el valor de cada red segun lo que responda el API correspondiente
                    if (type === 'facebook') {count = response.shares;} else
                    if (type === 'twitter') {count = response.count;} else
                    if (type === 'linkedin') {count = response.count;} else
                    {

                    } // google


                    // prevencion de error en caso de false o undefined
                    count = count ? count : 0;
                    element.textContent = count;
                });
            });
        },

        handleMaps: function handleMaps($boxes) {
            $boxes.ninjaMap();
        },

        showTarget: function showTarget(event) {
            event.preventDefault();
            $target = $('#' + event.currentTarget.getAttribute('data-target')).show();
        },

        scrollToTarget: function scrollToTarget(event) {
            event.preventDefault();
            event.stopPropagation();
            var targetPos = $(event.currentTarget.getAttribute('href')).offset().top,
            offset = parseInt(event.currentTarget.getAttribute('data-offset')),
            $parent = $(event.currentTarget).parent();

            if (offset) {
                targetPos = targetPos - offset;
                //added
                $parent.siblings().removeClass('sidebar__item--current');
                $parent.addClass('sidebar__item--current');
            }

            $('html, body').animate({ scrollTop: targetPos }, 500);
        },

        mosaic3d: function mosaic3d($container) {
            var $items = $container.find('.mosaic-item');
            setInterval(function () {
                $items.removeClass('mosaic-deployed');
                $items.random().addClass('mosaic-deployed');
                $items.not('.mosaic-deployed').random().addClass('mosaic-deployed');
            }, 2000);
        },

        ///////////////////////////////////////////////////////////
        /////////////////////////////// Delegaciones directas
        ///////////////////////////////////////////////////////////
        toggleTarget: function toggleTarget(event) {
            event.preventDefault();

            $(event.currentTarget.getAttribute('data-target')).toggleClass('deployed');

            // expansion para cuando quiero enfocar algo despues de mostrarlo
            if (event.currentTarget.getAttribute('data-focus')) {
                $(event.currentTarget.getAttribute('data-focus')).focus();
            }
        },

        tabControl: function tabControl(event) {
            event.preventDefault();

            var $button = $(event.currentTarget),
            $target = $('[data-tab-name="' + $button.data('target') + '"]');

            $button.siblings().removeClass('active');
            $target.siblings().removeClass('active');

            throttle(function () {
                $button.addClass('active');
                $target.addClass('active');
            });
        },

        deployParent: function deployParent(event) {
            event.preventDefault();
            $(event.currentTarget).parents(event.currentTarget.getAttribute('data-parent')).toggleClass('deployed');
        },

        showTab: function showTab(event) {
            event.preventDefault();
            var $item = $(event.currentTarget);

            $('.step-box__button[data-target="' + $item.data('target') + '"]').addClass('active').siblings().removeClass('active');
            $('[data-tabname="' + $item.data('target') + '"]').addClass('active').siblings().removeClass('active');
            $item.addClass('active').siblings().removeClass('active');
        },

        deployMainNav: function deployMainNav(event) {
            event.preventDefault();

            var $button = $(event.currentTarget),
            $mainNav = $('#main-nav');

            if ($button.is('.deployed')) {
                $button.removeClass('deployed');
                $mainNav.removeClass('deployed').css({
                    'max-height': 0 });


                $('#main-header').off('touchmove', this.blockScroll);

                document.body.style.overflow = 'auto';
                document.body.style.pointerEvents = 'auto';
            } else
            {
                $button.addClass('deployed');

                // la navegacion no deberia ser mas grande que la pantalla ofreciendo un scroll
                var windowHeight = $window.height();
                var headerHeight = $('#main-header').height();

                $('#main-header').css({
                    'pointer-events': 'auto' }).
                on('touchmove', this.blockScroll);

                $mainNav.css({
                    'max-height': windowHeight - headerHeight,
                    'pointer-events': 'auto' });


                /// ponemos la clase una vez que se termina la transicion css
                $mainNav.one('webkitTransitionend transitionend', function () {
                    $mainNav.addClass('deployed');
                    document.body.style.overflow = 'hidden';
                    document.body.style.pointerEvents = 'none';
                });
            }
        },

        deployMobileSearch: function deployMobileSearch(event) {
            event.preventDefault();

            var $button = $(event.currentTarget),
            $searchBox = $('#mobile-search-holder');

            $button.toggleClass('deployed');
            $searchBox.toggleClass('deployed');
        },

        showShortUrl: function showShortUrl(event) {
            event.preventDefault();
            event.stopPropagation();

            var self = this,
            $item = $(event.currentTarget),
            shortUrl = $item.data('link') || $('link[rel="shortlink"]').attr('href') || window.location.href,
            urlInput = $('<input class="tooltip-data-input" type="text" name="short-url" value="' + shortUrl + '" readonly>').get(0),
            $tooltip = $('<div />').attr({
                'id': 'short-url-tooltip-object',
                'class': 'regular-tooltip short-url' }).
            append(urlInput),
            position = $item.offset(),
            unloadFunc = function unloadFunc(e) {
                $('#short-url-tooltip-object').remove();
                $(this).off('click.tooltip');
            };


            // primero se saca cualquiera que actualmente se este mostrando
            $('#short-url-tooltip-object').remove();

            // se setean las propiedades y se adjunta al body
            $tooltip.appendTo('body').css({
                'position': 'absolute',
                'top': position.top - $tooltip.outerHeight() - 20,
                'left': position.left - $tooltip.outerWidth() + $item.outerWidth(),
                'opacity': 1 }).
            on('click', function (e) {
                e.stopPropagation();
            });

            urlInput.setSelectionRange(0, urlInput.value.length);

            $('body').on('click.tooltip', unloadFunc);
        },

        printPage: function printPage(event) {
            event.preventDefault();
            window.print();
        },

        sendPostByEmail: function sendPostByEmail(event) {
            event.preventDefault();

            var app = this,
            lightbox_promise = this.setLightBox('expert-contact'),
            ajax_promise = $.get(this.ajaxURL, {
                action: 'st_front_ajax',
                funcion: 'show_send_by_email_form',
                pid: $(event.currentTarget).data('pid') });


            $.when(lightbox_promise, ajax_promise).then(function (lightbox_info, ajax_response) {
                var $lightbox_bg = lightbox_info[0],
                $lightbox_content = lightbox_info[1],
                response = ajax_response[0];

                $lightbox_content.append(response);

                $lightbox_content.find('[data-validation="basic"]').validizr({
                    delegate_keyup: false,
                    notValidInputCallback: app.genericInvalidInputAction,
                    validFormCallback: function validFormCallback($form) {
                        var form_data = 'action=st_front_ajax&funcion=send_post_by_email&' + $form.serialize();

                        $form.css({
                            'opacity': '.2',
                            'pointer-events': 'none' });


                        $.ajax({
                            method: 'post',
                            url: app.ajaxURL,
                            dataType: 'json',
                            data: form_data }).
                        done(function (response) {
                            $form.html(response.feedback).css({
                                'opacity': '1',
                                'pointer-events': 'auto' });

                            app.isSending = false;
                        });
                    } });


                throttle(function () {
                    $lightbox_bg.addClass('loaded');
                });
            });
        },

        expandFootNote: function expandFootNote(event) {
            event.preventDefault();
            $(event.currentTarget).toggleClass('expanded');
        },

        inputControl: function inputControl(event) {
            var $item = $(event.currentTarget);

            if ($item.is('[type="radio"]') && $item.is(':checked') || $item.is('select')) {
                $('[data-role="' + $item.data('group') + '"]').
                removeClass('active').
                find('input, select, textarea').
                removeAttr('required');

                $('[data-role="' + $item.data('group') + '"][data-name="' + $item.val() + '"]').
                addClass('active').
                find('input, select, textarea').
                attr('required', true);
            }
        },

        goToTop: function goToTop(event) {
            event.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, 800);
        },

        collapseTaller: function collapseTaller(event) {
            event.preventDefault();
            var $button = $(event.currentTarget),
            $target = $('[data-child-name="' + $button.data('target') + '"]'),
            $btnplus = $button.children('.plus'),
            $all = $('.collapse-children__btn');

            // $all.removeClass('active');
            $target.toggleClass('active');
            $btnplus.toggleClass('active');
            $btnplus.text(function (i, text) {
                return text === '-' ? '+' : '-';
            });
            // $button.on('click', function(){
            //     $target.toggleClass('active');
            // });
        },

        loadCursos: function loadCursos(event) {
            var $element = $(event.currentTarget),
            $target = $($element.data('target'));

            // se informa la carga de datos
            $target.addClass('loading').html('<option value="">Cargando cursos</option>');

            $.getJSON(this.ajaxURL, {
                action: 'st_front_ajax',
                funcion: 'get_cursos_by_sede',
                sede: $element.val() }).
            then(function (response) {
                // console.log(response);
                $target.removeClass('loading').html(response.html);
            });
        } };


    var app = new App();

    $document.ready(function () {app.onReady && app.onReady();});

    $window.on({
        'load': function load() {app.onLoad && app.onLoad();},
        'resize': function resize() {app.onResize && app.onResize();} });


})(window, document, jQuery);